module.exports = __webpack_public_path__ + "static/media/discussion.a8ba2357.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/discussion.jpg
// module id = 470
// module chunks = 0